import React, { useState } from "react";
import iconCheck from "../assets/images/icon-check.svg";
import iconX from "../assets/images/icon-x.svg";
import boiteOpen from "../assets/images/wecook-open-box.png";
import iconTruck from "../assets/images/icon-truck.svg";
import iconCrochet from "../assets/images/crochet-plein.svg";
import "./Date.css";

const DAY_NAMES = [
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];

const MONTH_NAMES = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

const FEATURES = [
  "Boîte de carton recyclable",
  "Coussin isolant fait de matière recyclée",
  "Sacs de glace recyclables",
];

function buildCalendar(numWeeks = 5) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(today);
  start.setDate(today.getDate() - today.getDay()); // rewind to Sunday

  const weeks = [];
  for (let w = 0; w < numWeeks; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      const date = new Date(start);
      date.setDate(start.getDate() + w * 7 + d);
      week.push(date);
    }
    weeks.push(week);
  }
  return weeks;
}

function groupByMonth(weeks) {
  const groups = [];
  let current = null;
  weeks.forEach((week) => {
    const month = week[3].getMonth(); // use Wednesday to determine month
    if (!current || current.month !== month) {
      current = { month, label: MONTH_NAMES[month], weeks: [] };
      groups.push(current);
    }
    current.weeks.push(week);
  });
  return groups;
}

const MONTH_NAMES_LOWER = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

function formatDate(date) {
  if (!date) return "";
  return `${DAY_NAMES[date.getDay()]}, ${date.getDate()} ${MONTH_NAMES_LOWER[date.getMonth()]}`;
}

function isSameDay(a, b) {
  return (
    a &&
    b &&
    a.getDate() === b.getDate() &&
    a.getMonth() === b.getMonth() &&
    a.getFullYear() === b.getFullYear()
  );
}

export default function DeliveryDate({ onConfirm: onConfirmProp }) {
  const [selected, setSelected] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const monthGroups = groupByMonth(buildCalendar(5));

  const handleDateClick = (date) => {
    setSelected(date);
    setShowPopup(true);
  };

  const handleClose = () => setShowPopup(false);
  const handleConfirm = () => {
    setShowPopup(false);
    if (onConfirmProp) onConfirmProp(selected);
  };
  const handleModify = () => {
    setSelected(null);
    setShowPopup(false);
  };

  return (
    <div className="delivery-date">
      {/* ── Left panel ── */}
      <div className="dd-left">
        <h1 className="dd-title">Quand voulez vous recevoir votre commande</h1>

        <div className="dd-address">
          <div className="dd-address-left">
            <img src={iconCrochet} alt="" className="dd-address-icon" />
            <span>J4Z 3T9</span>
          </div>
          <button className="dd-address-btn">Modifier</button>
        </div>

        <div className="dd-delivery-type">
          <img src={iconTruck} alt="" />
          <span>Livraison à domicile ou au bureau</span>
        </div>

        <div className="dd-calendar">
          {monthGroups.map((group, gi) => (
            <div key={group.month} className="cal-month-group">
              <div className="cal-month-label">{group.label}</div>

              {/* Day-name headers shown only on the first month */}
              {gi === 0 && (
                <div className="cal-row">
                  {DAY_NAMES.map((name, i) => (
                    <div
                      key={i}
                      className={`cal-header${i === 0 || i === 6 ? " cal-header--weekend" : ""}`}
                    >
                      {name}
                    </div>
                  ))}
                </div>
              )}

              {group.weeks.map((week, wi) => (
                <div key={wi} className="cal-row">
                  {week.map((date, di) => {
                    const weekend = di === 0 || di === 6;
                    const isSelected = isSameDay(date, selected);
                    return (
                      <button
                        key={di}
                        className={[
                          "cal-day",
                          weekend ? "cal-day--weekend" : "cal-day--available",
                          isSelected ? "cal-day--selected" : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        onClick={() => !weekend && handleDateClick(date)}
                        disabled={weekend}
                        aria-pressed={isSelected}
                      >
                        {date.getDate()}
                      </button>
                    );
                  })}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ── Right panel ── */}
      <div className="dd-right">
        <div className="dd-right-content">
          <h2 className="dd-right-title">
            Nous gardons vos repas frais de notre porte à la vôtre!
          </h2>
          <ul className="dd-features">
            {FEATURES.map((text, i) => (
              <li key={i} className="dd-feature">
                <img src={iconCheck} alt="" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="dd-box-image">
          <img src={boiteOpen} alt="Boîte de livraison WeCook" />
        </div>
      </div>

      {/* ── Date popup ── */}
      {showPopup && (
        <div className="popup-overlay" onClick={handleClose}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={handleClose}
              aria-label="Fermer"
            >
              <img src={iconX} alt="" />
            </button>

            <div className="popup-top">
              <h3 className="popup-title">Livraison gratuite</h3>
              <div className="popup-card">
                <div className="popup-row">
                  <span>J4Z 3T9</span>
                  <img src={iconCheck} alt="" className="popup-row-icon" />
                </div>
                <div className="popup-row">
                  <span>{formatDate(selected)}</span>
                  <img src={iconCheck} alt="" className="popup-row-icon" />
                </div>
              </div>
            </div>

            <div className="popup-actions">
              <button className="popup-confirm" onClick={handleConfirm}>
                Confirmer
              </button>
              <button className="popup-modify" onClick={handleModify}>
                Modifier
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
